import React, { useState, useEffect, useContext, version, useLayoutEffect } from "react";
import axios from "axios";
import { useQuery, useQueryClient } from "react-query";
import useLocalStorage from "react-use-localstorage";
import { FormattedMessage } from "react-intl";
import { useHistory, useParams } from "react-router-dom";
import "./new-video-item.scss";
import Schedule from "./schedule";
import { PreLoader } from "../components/preloader";
import { DownloadIcon } from "../components/svgs";
import {
  ScheduleEndpointResponseObject,
  Version,
  Video,
  Videos,
  Webcams,
} from "../types/presentation";
import ImgToolTip from "../components/ImgTooltip";

import UserContext from "../contexts/user";
import NewSchedule from "./new-schedule";
import { Field } from "formik";
import { ReactCommonSwitch } from "../helpers/formik";
import { boolean } from "yup/lib/locale";
import { Button } from "reactstrap";
import { id } from "date-fns/locale";
import ReactPlayer from "react-player";
// import { DateTime, Duration } from "luxon";
import { useIntl } from "react-intl";
// import advancedFormat from 'dayjs/plugin/advancedFormat'
import dayjs from "dayjs";
import VideoModal from "../components/video-modal";
import SproutVideo from "../components/sprout-video";
import SproutThumbnail from "../components/sprout-thumbnail";
import { duration } from "../helpers/duration";
import getS3ImageUrl from "../helpers/getS3ImageUrl";
import { log } from "console";
import getUuid from "uuid-by-string";
import EventContext from "../contexts/event";
import ValidationModel from "../components/validation-model";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ProgressBar from "@ramonak/react-progress-bar";
import Swal from "sweetalert2";
import useAxios from "axios-hooks";
import AlertModal from "../components/alert-modal";

const NewVideoItem: React.FC<{
  version: Version;
  PresentationId: string;
  token: string;
  locale: string;
  idx: number;
  onChangeCallBack: Function;
  openVideoModal: any;
  deleteVersion: any;
  onStatusChange: (idx: boolean, status: any) => any;
  onVideoPlay: (S_t: string, V_ID: string) => void;
  onActivityChange: (
    idx: number,
    open: any,
    status: any,
    online: boolean,
    versionId: string
  ) => any;
  isOpen: boolean;
  setLocale: any;

  status_p: boolean;
}> = ({
  onStatusChange,
  locale,
  setLocale,
  isOpen,
  status_p,
  onActivityChange,
  idx,
  PresentationId,
  token,
  openVideoModal,
  deleteVersion,
  version, onChangeCallBack
}) => {
    const intl = useIntl();
    // const date_check = DateTime.fromISO(date).toFormat("dd LLLL yyyy");
    // const formatYmd = d => d.toISOString().slice(0, 10);
    // formatYmd(date);
    // DateTime.fromISO(date)
    //   .setLocale(intl.locale)
    //   .toLocaleString(DateTime.DATE_HUGE);

    //  DateTime.fromFormat(date, "yyyy-MM-dd").toFormat('D')
    const [showVideoModal, setsShowVideoModal] = useState(true);
    const [url, setUrl] = useState("");
    const [videoUrl, setVideoUrl] = useState("");
    const [time, setTime] = useState("");
    const history = useHistory();
    const eventContext = useContext(EventContext);
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertType, setAlertType] = useState("");
    const [pptmessage, setPptMessage] = useState("");
    const [processPercentage, setProcessPercentage] = useState(version.percent);
    const [versionPptUrl, setVersionPptUrl] = useState("#");
    const [addWebcam, setAddWebcam] = useState(false);
    const [showSaveButton, setShowSaveButton] = useState(false);
    const [camVideoAdded, setCamVideoAdded] = useState(false);

    const [leftVideo, setLeftVideo] = useState("");
    const [LeftVideo, sLeftVideo] = useState("");
    const [progress, setProgress] = useState(0);

    const handleAlertModal = () => {
      setShowValidationModal(!showValidationModal);
    };

    const handleLoadingAlertModal = () => {
      setShowAlertModal(!showAlertModal);
    };

    async function getPptURL() {
      let pptURL;
      if (version.pptUrl)
        pptURL = await getS3ImageUrl(version.pptUrl);
      else {
        pptURL = "#";
      }
      setVersionPptUrl(pptURL);
    }


    useLayoutEffect(() => {
      console.log(
        "version data",
        version
      );
      if (version.webcam) {
        axios
          .get(
            `${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/video-details/${PresentationId}/video/${version.webcam.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            //  console.log(
            //   "response -----------------------------------------------------------------------------------------------------",
            //   response.data.thumbnails[0]
            // );
            setUrl(response.data.thumbnails[0]);
            setTime(response.data.duration);
          })

          .catch((error) => {
            console.log(error);
          });
      }

      if (version.video) {
        axios
          .get(
            `${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/video-details/${PresentationId}/video/${version.video.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            //  console.log(
            //   "response -----------------------------------------------------------------------------------------------------",
            //   response.data.thumbnails[0]
            // );
            if (time == "") {
              setVideoUrl(response.data.thumbnails[0]);
              setTime(response.data.duration);
            }
            // setDuration(response.data.duration);
          })
          .catch((error) => {
            console.log(error);
          });
      }

      getPptURL();

    }, []);

    const handleVideoClose = () => {
      setsShowVideoModal(!showVideoModal);
    };

    // upload video to backend and s3
    async function uploadData(versionId: string) {
      const webCamFile = LeftVideo;
      setShowAlertModal(true);
      const videoTokenResponse = await getVideoToken();
      const uploadToken = videoTokenResponse.data;

      // set form data for upload
      const formData = new FormData();
      formData.append("source_video", webCamFile);
      formData.append("token", uploadToken);

      // form data
      const videoUpload = await uploadVideo({
        data: formData,
        onUploadProgress: progressEvent => {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          setProgress(percentCompleted);
        }
      });

      console.log("update-version", {
        id: videoUpload.data.id,
        security_token: videoUpload.data.security_token,
      });


      // update data to backend
      await axios
        .patch(
          ` ${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/update-version`,
          {
            versionId: versionId,
            presentationId: PresentationId,
            webcam: {
              id: videoUpload.data.id,
              security_token: videoUpload.data.security_token,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        ).then(value => {
          setProgress(0);
          setTimeout(() => {
            setShowAlertModal(false);
            setShowSaveButton(false);
            setCamVideoAdded(true);
            //  onChangeCallBack();
          }, 8000);


          console.log("update-version", value);
        })
    }

    const [{ loading: getVideoTokenLoading }, getVideoToken] = useAxios(
      {
        url: `${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/video-token/${PresentationId}`,
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      {
        manual: true,
      }
    );

    const [{ data, loading, error }, uploadVideo] = useAxios({
      url: "https://api.sproutvideo.com/v1/videos",

      method: "POST",
      data: {
        download_hd: true,
      },
    });
    console.log(version, "versio");


    return (
      <div>
        <div className="new-video-item web-new-video-item m-b-20">
          <div className="d-lg-block">
            <div className="no-gutters row new-video-row">
              <div className="col-sm-1 col-md-1 col-lg-1 light-bg left-border version-list-height">
                {version.option ? (
                  <img
                    src={!camVideoAdded ? `/icons/${version.option}.svg` : '/icons/first.svg'}
                    className="large "
                    alt="file only"
                    width="42"
                    height="42"
                  />
                ) : (
                  <img
                    className="large "
                    src="/icons/video-completed.svg"
                    alt="file only"
                    width="42"
                  />
                )}
              </div>
              <div className="col-sm-3 col-md-3 col-lg-4 bg-white center-row version-list-height">
                <div className="row">
                  <div className="col-sm-10 version-list">
                    <div>
                      <span className="title">
                        {dayjs(version.date).format("h:mm A")}
                        {/* 11h00  h:mm A */}
                      </span>
                    </div>
                    <span className="sub-title">
                      {dayjs(version.date).format("DD/MM/YYYY")}
                    </span>
                    {time ? (
                      <span className="sub-time">
                        `Duration : {duration(time)} `
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className="col-sm-2 d-flex flex-row"
                  >
                    {/* <Button > */}
                    <img
                      className="trash m-r-5"
                      src="/icons/trash.svg"
                      alt="file only"
                      width="14"
                      onClick={
                        function () {
                          setAlertType("Success");
                          setPptMessage("Are you sure you want to delete");
                          setShowValidationModal(true);
                        }
                      }
                      style={{ cursor: "pointer" }}
                    />
                    {/* Button to edit the presentation video, webcam, ppt file, path to the video editor page */}
                    {version.option !== "four" &&
                      (<img
                        className="trash m-r-5"
                        src="/icons/edit_icon_black.svg"
                        alt="file only"
                        width="15"
                        onClick={
                          function () {
                            if (version.status === "success") {
                              history.push({
                                pathname: `/${eventContext.slug}/videoeditor/${PresentationId}`,
                                state: { version } // Passing version data
                              });
                            }else {
                              //show a modal or something to let them know that the presentation is not ready
                              alert("The presentation is not ready!")
                            }
                          }
                        }
                        style={{ cursor: "pointer", opacity: '1' }}

                      // style={{ cursor: `${version.status === "success " ? 'pointer':'default'}`, opacity: `${version.status === "success " ? '1':'0.5'}` , }}
                      />)}
                    {/* </Button> */}
                  </div>
                </div>
              </div>

              {version.option == "four" && version.status == "success" ? (
                <div
                  className="col-sm-3 col-md-3 col-lg-2 dark-bg status-row open version-list-height"
                // onClick={function () {
                //   history.push(
                //     `/${eventContext.slug}/my-presentations/${PresentationId}/video/${version.versionId}/watch`
                //   );
                // }}
                >
                  {/* <img
                  className="large open"
                  src="/icons/video-completed.svg"
                  alt="file only"
                  width="32"
                /> */}
                  <span>Success</span>
                </div>
              ) : version.option != "four" && version.status == "success" ? (
                <div
                  className="col-sm-3 col-md-3 col-lg-2 dark-bg status-row open version-list-height"
                  onClick={function () {
                    history.push(
                      `/${eventContext.slug}/my-presentations/${PresentationId}/video/${version.versionId}/watch`
                    );
                  }}
                >
                  <img
                    className="large open"
                    src="/icons/video-completed.svg"
                    alt="file only"
                    width="32"
                  />
                  <span>Open</span>
                </div>
              ) : version.status == "failed" ? (
                <div className="col-sm-3 col-md-3 col-lg-2 bg-danger status-row version-list-height" >
                  <img
                    className="large status-loading"
                    src="/icons/video-error1.svg"
                    alt="file only"
                    width="32"
                  />
                  <span
                  // className=" Error" st
                  >
                    Error
                  </span>
                </div>
              ) : version.status == "processing" ||
                version.status == "pending" ? (
                // version.status == "Loading" ?
                <div className="col-sm-3 col-md-3 col-lg-2 bg-dark status-row version-list-height">
                  <img
                    className="large status-loading"
                    src="/icons/video-loading.svg"
                    alt="file only"
                    width="32"
                  />
                  <span className="loading-typography">Processing {version.percent ? version.percent : 0}%</span>
                  { console.log(
                  "----------------------------------------version.percent",
                  version.percent
                )}
                  <div
                    // style={{
                    //   width: "100%",
                    // }}
                    className="outer_lining"
                  >
                    {console.log(
                      "----------------------------------------version.percent",
                      version.status
                    )}
                    {/* <div
                    style={{
                      width: `${version.percent ? version.percent : 0}%`,
                    }}
                    className="lining"
                  ></div> */}

                    <ProgressBar
                      completed={version.percent ? version.percent : 0}
                      // completed={processPercentage ? processPercentage : 0}
                      isLabelVisible={false}
                      height="2px"
                      bgColor="#24b2ff"
                      baseBgColor="#607c8b99"
                    />
                  </div>

                  {/* <div className="lininga"></div> */}
                </div>
              ) : version.status === "PPT to PDF file convert failed" ? (
                <div className="col-sm-3 col-md-3 col-lg-2 bg-danger status-row version-list-height" style={{ fontSize: 12, textAlign: "right", paddingTop: 10, paddingRight: 10, paddingLeft: 5 }}>
                  <img
                    className="large status-loading"
                    src="/icons/video-error1.svg"
                    alt="file only"
                    width="32"
                  />
                  <span
                  // className=" Error"
                  >
                    PPT TO PDF FILE CONVERT FAILED
                  </span>
                </div>
              ) : (
                ""
              )}

              <Button
                className="col-sm-3 col-md-3 col-lg-2 light-bg right-border version-list-height "
                onClick={
                  () => {
                    onStatusChange(!isOpen, version.status);
                    console.log(
                      "is_open-------------------------------------",
                      isOpen
                    );
                  }

                  // setOpenDetails(!openDetails)
                }
                style={{ border: "none" }}
              >
                {isOpen ? (
                  <img
                    className="large"
                    src="/icons/expand-close.svg"
                    alt="file only"
                    width="24"
                  />
                ) : (
                  <img
                    className="large"
                    src="/icons/expand-open.svg"
                    alt="file only"
                    width="24"
                  />
                )}
              </Button>
              {
                <div className="col-sm-3 col-md-3 col-lg-2 ">
                  <div className="me-2 py-2 text-decoration-none ">
                    <label
                      style={{ cursor: `${version.status !== "processing" && version.status !== "pending" ? "pointer" : "default"}` }}
                      onClick={() => {
                        console.log("version.status", version.status)
                        if (version.status !== "processing" && version.status !== "pending") {
                          onActivityChange(
                            idx,
                            status_p,
                            version.status,
                            version.online,
                            version.versionId
                          );
                          console.log(
                            "status_p-------------------------------------",
                            status_p
                          );
                        }
                      }}
                      // className="status_switch_label status_switch_input"
                      className={`status_switch_label
                     ${
                        //  version.online
                        status_p
                          ? "status_switch_label "
                          : " status_switch_input status_switch_disable"
                        }
                    `}
                    >
                      {status_p ? (
                        <>
                          <div>
                            <span className="online_typography">Online</span>

                            <img
                              className="onine_circle"
                              src="/icons/Ellipse 18.svg"
                            // alt="file only"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <img
                              className="offline_circle"
                              src={`${version.status !== "processing" && version.status !== "pending" ? "/icons/Ellipse 18.svg" : "/icons/Ellipse 18_disable.svg"}`}
                            />
                            <span className="offline_typography">Offline</span>
                          </div>
                        </>
                      )}
                    </label>
                  </div>
                </div>
              }
            </div>
            {isOpen ? (
              version.option == "first" ? (
                <div className="col-sm-9 col-md-9 col-lg-9 padding-0 new-video-expand new-video-expand-open">
                  <div className="no-gutters row ">
                    <div className="col-sm-5 col-md-5 col-lg-5 ">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-download-ppt-${version.date}`}>
                            {/* {intl.formatMessage({id: tooltiptext})} */}
                            Webcam Video
                          </Tooltip>
                        }
                      >
                        <div className="left-box border-box">
                          {version.webcam ? (
                            <>
                              {/* <div
                            // className="border-box"
                            style={{ height: "187px" }}
                            // onClick={() => openVideoModal(version.webcam)}
                          > */}
                              {/* <img
                              title="webcam Video"
                              // cursour pointer
                              className="sprout-image"
                              src={`${url}`}
                            /> */}
                              <SproutVideo
                                id={version.webcam.id}
                                security_token={version.webcam.security_token}
                                skip={0}
                                className="video-modal-content-first"
                                volume={1}

                                showcontrols={true}
                              />
                              {/* </div> */}
                            </>
                          ) : (
                            <img
                              className=""
                              src="/icons/video-close.svg"
                              alt="file only"
                              width="46"
                            />
                          )}
                        </div>
                      </OverlayTrigger>
                      <div className="d-flex bottom-left-main ">
                        {/* pptbottom */}
                        <div
                          className="left-bottom-box
                    left-box-main-open border-box
                    "
                          style={{ height: "172px ", width: "207px " }}
                        >
                          <a
                            // className="trash"
                            className="btn_download_photos"
                            // href={`${process.env.REACT_APP_ASSET_URL}${pdfUrl}`}
                            href={
                              versionPptUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <ImgToolTip
                              intl={intl}
                              placement="top"
                              tooltiptext="schedule.link.download"
                              id={`tooltip-download-ppt-${version.date}`}
                              img="/icons/download.png"
                              className={""}

                            />
                          </a>
                          {/* <div
                          style={{
                            textAlign: "center",
                          }}
                        > */}
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-download-ppt-${version.date}`}
                              >
                                {/* {intl.formatMessage({id: tooltiptext})} */}
                                Presentation File
                              </Tooltip>
                            }
                          >
                            <img
                              style={{
                                // width: "100%",
                                // height: "100%",
                                marginTop: "14%",
                                marginRight: "33%",
                                marginLeft: "41%",
                                marginBottom: "14%",
                              }}
                              src={"/icons/four.svg"}
                            />
                          </OverlayTrigger>
                          <span className="presentation_name_typography">
                            {version.fileName}
                          </span>
                          {/* </div> */}
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-7 col-md-7 col-lg-7 rightbox_content">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-download-ppt-${version.date}`}>
                            {/* {intl.formatMessage({id: tooltiptext})} */}
                            Presentation File
                          </Tooltip>
                        }
                      >
                        <div className="right-box border-box">
                          {version.video ? (
                            <>
                              <div style={{ height: "285px" }}>
                                <SproutVideo
                                  id={version.video.id}
                                  security_token={version.video.security_token}
                                  skip={0}
                                  className="video-modal-content-first"
                                  volume={1}
                                  showcontrols={true}
                                />
                              </div>
                            </>
                          ) : (
                            <img
                              className=""
                              src="/icons/video-close.png"
                              alt="file only"
                              width="55"
                            />
                          )}
                        </div>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              ) : version.option == "two" ? (
                !addWebcam ? <div className=" col-sm-9 col-md-9 col-lg-9 padding-0 new-video-expand new-video-expand-version-two  ">
                  <div className="no-gutters row ">
                    <div className="col-sm-8 col-md-8 col-lg-8">
                      <div className="d-flex bottom-left-main ">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-download-ppt-${version.date}`}>
                              {/* {intl.formatMessage({id: tooltiptext})} */}
                              Presentation Video
                            </Tooltip>
                          }
                        >
                          <div
                            className=" border-box left-bottom-box-version-two
                    "
                          >
                            {version.video ? (
                              <>
                                {/* <img
                              title="Presentation Video"
                              className="sprout-image-version-two"
                              src={`${videoUrl}`}
                              onClick={() => openVideoModal(version.video)}
                            /> */}
                                <SproutVideo
                                  id={version.video.id}
                                  security_token={version.video.security_token}
                                  skip={0}
                                  className="video-modal-content-first"
                                  volume={1}
                                  showcontrols={true}
                                />
                              </>
                            ) : (
                              <img
                                className=""
                                src="/icons/video-close.png"
                                alt="file only"
                                width="55"
                              />
                            )}
                            <div className="save-videos-form d-flex" style={{ justifyContent: 'start' }}>
                              <Button
                                color="primary"
                                className="save btn-save"
                                type="button"
                                onClick={function () {
                                  Swal.fire({
                                    title: intl.formatMessage({ id: 'add.webcam.message' }),
                                    text: intl.formatMessage({ id: 'add.webcam.popup.message' }),
                                    icon: "question",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Add"
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      setAddWebcam(true);
                                      setShowSaveButton(true)
                                    }
                                  });
                                }}
                              >
                                Add webcam
                              </Button>

                            </div>
                          </div>
                        </OverlayTrigger>
                      </div>
                    </div>

                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <div className="right-box-version-two border-box">
                        <a
                          className="btn_download_photos_version_two"
                          href={
                            versionPptUrl
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <ImgToolTip
                            intl={intl}
                            placement="top"
                            tooltiptext="schedule.link.download"
                            id={`tooltip-download-ppt-${version.date}`}
                            img="/icons/download.png"
                            className={"download_icon_version_two"}
                          />
                        </a>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-download-ppt-${version.date}`}>
                              {/* {intl.formatMessage({id: tooltiptext})} */}
                              Presentation File
                            </Tooltip>
                          }
                        >
                          <img
                            style={{
                              // width: "100%",
                              // height: "100%",
                              marginTop: "24%",

                              marginLeft: "34%",
                            }}
                            alt="presenmtation file"
                            src={"/icons/four.svg"}
                          />
                        </OverlayTrigger>
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: "10%",
                          }}
                        >
                          <span className="presentation_name_typography">
                            {version.fileName}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> :
                  <div className="col-sm-9 col-md-9 col-lg-9 padding-0 new-video-expand new-video-expand-open">
                    <div className="no-gutters row ">
                      <div className="col-sm-5 col-md-5 col-lg-5 ">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-download-ppt-${version.date}`}>
                              {/* {intl.formatMessage({id: tooltiptext})} */}
                              Webcam Video
                            </Tooltip>
                          }
                        >
                          <div className="left-box border-box">
                            {(

                              leftVideo ? (
                                <ReactPlayer
                                  className="react-player"
                                  url={leftVideo}
                                  width="100%"
                                  // height="38vh"
                                  height="100%"
                                  controls={true}
                                />
                              ) :
                                <div className={'video-two-cam'}>
                                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img
                                      className=""
                                      src="/icons/Ico-cam.svg"
                                      alt="file only"
                                      width="52"
                                    />
                                    <img
                                      className=""
                                      style={{ position: 'absolute', right: '72px', top: '-12px' }}
                                      src="/icons/plus-circle.svg"
                                      alt="file only"
                                      width="25"
                                    />
                                  </div>
                                  <p>
                                    {intl.formatMessage({ id: 'drag.drop.video' })}{" "}
                                    <span> {intl.formatMessage({ id: 'select.video' })}</span>
                                  </p>
                                  <input
                                    className="file-input"
                                    type="file"
                                    accept="video/*"
                                    hidden={false}
                                    onChange={function (event: any) {
                                      setLeftVideo(
                                        URL.createObjectURL(
                                          event.target.files[0]
                                        )
                                      );
                                      sLeftVideo(event.target.files[0]);
                                    }}


                                  />
                                </div>
                            )}
                          </div>
                        </OverlayTrigger>
                        <div className="d-flex bottom-left-main ">
                          {/* pptbottom */}
                          <div
                            className="left-bottom-box
                    left-box-main-open border-box
                    "
                            style={{ height: "172px ", width: "207px " }}
                          >
                            <a
                              // className="trash"
                              className="btn_download_photos"
                              // href={`${process.env.REACT_APP_ASSET_URL}${pdfUrl}`}
                              href={
                                versionPptUrl
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <ImgToolTip
                                intl={intl}
                                placement="top"
                                tooltiptext="schedule.link.download"
                                id={`tooltip-download-ppt-${version.date}`}
                                img="/icons/download.png"
                                className={""}

                              />
                            </a>
                            {/* <div
                          style={{
                            textAlign: "center",
                          }}
                        > */}
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip
                                  id={`tooltip-download-ppt-${version.date}`}
                                >
                                  {/* {intl.formatMessage({id: tooltiptext})} */}
                                  Presentation File
                                </Tooltip>
                              }
                            >
                              <img
                                style={{
                                  // width: "100%",
                                  // height: "100%",
                                  marginTop: "14%",
                                  marginRight: "33%",
                                  marginLeft: "41%",
                                  marginBottom: "14%",
                                }}
                                src={"/icons/four.svg"}
                              />
                            </OverlayTrigger>
                            <span className="presentation_name_typography">
                              {version.fileName}
                            </span>
                            {/* </div> */}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-7 col-md-7 col-lg-7 rightbox_content">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-download-ppt-${version.date}`}>
                              {/* {intl.formatMessage({id: tooltiptext})} */}
                              Presentation File
                            </Tooltip>
                          }
                        >
                          <div className="right-box border-box">
                            {version.video ? (
                              <>
                                <div style={{ height: "285px" }}>
                                  <SproutVideo
                                    id={version.video.id}
                                    security_token={version.video.security_token}
                                    skip={0}
                                    className="video-modal-content-first"
                                    volume={1}
                                    showcontrols={true}
                                  />
                                </div>
                              </>
                            ) : (
                              <img
                                className=""
                                src="/icons/video-close.png"
                                alt="file only"
                                width="55"
                              />
                            )}
                          </div>
                        </OverlayTrigger>

                        {showSaveButton && (<div className="save-videos-form d-flex">
                          <Button
                            color="primary"
                            className="cancel btn-cancel"
                            type="button"
                            onClick={function () {
                              setAddWebcam(false);
                              setShowSaveButton(false);
                            }}
                          >
                            Cancel
                          </Button>

                          <Button
                            color="primary"
                            className="save btn-save"
                            type="submit"
                            onClick={function () {
                              console.log("version-data", version);
                              uploadData(version.versionId);
                            }}>
                            Save
                          </Button>

                        </div>)}
                      </div>

                    </div>
                  </div>
              ) : version.option == "three" ? (
                <div className=" col-sm-9 col-md-9 col-lg-9 padding-0 new-video-expand new-video-expand-version-two  ">
                  <div className="no-gutters row ">
                    <div className="col-sm-8 col-md-8 col-lg-8">
                      <div className="d-flex bottom-left-main ">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-download-ppt-${version.date}`}>
                              {/* {intl.formatMessage({id: tooltiptext})} */}
                              Presentation Video
                            </Tooltip>
                          }
                        >
                          <div
                            className=" border-box left-bottom-box-version-two
                  "
                          >
                            {version.video ? (
                              <>
                                {/* <img
                              title="Presentation Video"
                              className="sprout-image-version-two"
                              src={`${videoUrl}`}
                              onClick={() => openVideoModal(version.video)}
                            /> */}
                                <SproutVideo
                                  id={version.video.id}
                                  security_token={version.video.security_token}
                                  skip={0}
                                  className="video-modal-content-first"
                                  volume={1}
                                  showcontrols={true}
                                />
                              </>
                            ) : (
                              <img
                                className=""
                                src="/icons/video-close.png"
                                alt="file only"
                                width="55"
                              />
                            )}
                          </div>
                        </OverlayTrigger>
                      </div>
                    </div>

                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <div className="right-box-version-two border-box">
                        <a
                          className="btn_download_photos_version_two"
                          href={
                            versionPptUrl
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <ImgToolTip
                            intl={intl}
                            placement="top"
                            tooltiptext="schedule.link.download"
                            id={`tooltip-download-ppt-${version.date}`}
                            img="/icons/download.png"
                            className={"download_icon_version_two"}
                          />
                        </a>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-download-ppt-${version.date}`}>
                              {/* {intl.formatMessage({id: tooltiptext})} */}
                              Presentation File
                            </Tooltip>
                          }
                        >
                          <img
                            style={{
                              // width: "100%",
                              // height: "100%",
                              marginTop: "24%",

                              marginLeft: "34%",
                            }}
                            src={"/icons/four.svg"}
                          />
                        </OverlayTrigger>
                        <div
                          style={{
                            textAlign: "center",
                            marginBottom: "10%",
                          }}
                        >
                          <span className="presentation_name_typography">
                            {version.fileName}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : version.option == "four" ? (
                <div className="col-sm-9 col-md-9 col-lg-9 padding-0 new-video-expand-version-two  new-video-expand ">
                  <div className="no-gutters row ">
                    <div className="col-sm-8 col-md-8 col-lg-8 ">
                      <div className="d-flex bottom-left-main ">
                        <div
                          className="left-bottom-box-version-four
                     border-box
                    "
                          // left-box-main-open
                          style={{ height: "172px ", width: "207px " }}
                        >
                          <a
                            className="btn_download_photos_version_four"
                            href={
                              versionPptUrl
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <ImgToolTip
                              intl={intl}
                              placement="top"
                              tooltiptext="schedule.link.download"
                              id={`tooltip-download-ppt-${version.date}`}
                              img="/icons/download.png"
                              className={""}
                            />
                          </a>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-download-ppt-${version.date}`}
                              >
                                {/* {intl.formatMessage({id: tooltiptext})} */}
                                Presentation Video
                              </Tooltip>
                            }
                          >
                            <img
                              style={{
                                // width: "100%",
                                // height: "100%",
                                marginTop: "15%",

                                marginLeft: "0px",
                              }}
                              src={"/icons/four.svg"}
                            />
                          </OverlayTrigger>
                          <div
                            style={{
                              textAlign: "center",
                              marginBottom: "10%",
                            }}
                          >
                            <span className="presentation_name_typography">
                              {version.fileName}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="new-video-item responsive-new-video-item m-b-20">
          <div className="d-lg-block">
            <div className="no-gutters row new-video-row">
              <div
                className="
            col-lg-4 bg-white top-items center-row"
              >
                <div className="row">
                  <div className="col-sm-12">
                    <div>
                      {/* <Button > */}
                      <a
                        href={
                          versionPptUrl
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="upload"
                          src="/icons/Groupe 114.svg"
                          alt="file only"
                          width="16"
                          style={{ cursor: "pointer" }}
                        />
                      </a>
                      {/* </Button> */}
                    </div>
                    <div>
                      <span className="title font_style">
                        {dayjs(version.date).format("h:mm A")}
                      </span>
                    </div>
                    <div className="margin_style">
                      <span className="sub-title font_style">
                        {dayjs(version.date).format("DD/MM/YYYY")}
                      </span>
                      {time ? (
                        <>
                          <img
                            src="/icons/Groupe 127.svg"
                            alt="file only"
                            width="12"
                            style={{ cursor: "pointer" }}
                          />
                          <span className="sub-time ">
                            `Duration : {duration(time)} `{" "}
                          </span>
                        </>
                      ) : (
                        ""
                      )}
                    </div>

                    <div
                      onClick={
                        function () {
                          setAlertType("Success");
                          setPptMessage("Are you sure you want to delete");
                          setShowValidationModal(true);
                        }
                        // deleteVersion(version.versionId);
                        //  console.log(
                        //   "version_Id--------------------------",
                        //   version_Id
                        // );
                      }
                    >
                      {/* <Button > */}
                      <img
                        className="trash"
                        src="/icons/trash.svg"
                        alt="file only"
                        width="14"
                        style={{ cursor: "pointer" }}
                      />
                      {/* </Button> */}
                    </div>
                    {
                      <div className="col-sm-3 col-md-3 col-lg-2">
                        <span className="me-2 py-2 text-decoration-none link divider fs-6">
                          <label
                            style={{ cursor: `${version.status !== "processing" && version.status !== "pending" ? "pointer" : "default"}` }}
                            onClick={() => {
                              console.log("version.status 1", version.status)
                              // @ts-ignore
                              if (version.status !== "processing" && version.status !== "pending") {
                                onActivityChange(
                                  idx,
                                  status_p,
                                  version.status,
                                  version.online,
                                  version.versionId
                                );

                              }
                              //  console.log(
                              //   `this is toggle status inside on click ${statue}`
                              // );
                            }}
                            // className="status_switch_label status_switch_input"
                            className={`status_switch_label
                     ${version.online
                                ? "status_switch_label "
                                : " status_switch_input"
                              }
                    `}

                          >
                            {version.online ? (
                              <>
                                <div>
                                  <span className="online_typography">
                                    Online
                                  </span>

                                  <img
                                    className="onine_circle"
                                    src="/icons/Ellipse 18.svg"
                                  // alt="file only"
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                <div>
                                  <img
                                    className="offline_circle"
                                    src="/icons/Ellipse 18.svg"
                                  />
                                  <span className="offline_typography">
                                    Offline
                                  </span>
                                </div>
                              </>
                            )}
                          </label>
                        </span>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div className="row bottom-items">
                <div
                  col-sm-3
                  col-md-2
                  className="col-lg-3 light-bg left-border status_design "
                >
                  <img
                    src={`/icons/${version.option}.svg`}
                    alt="file only"
                    width="50"
                  />
                </div>
                {version.option == "four" && version.status == "success" ? (
                  <div className="col-sm-3 col-md-3 col-lg-2 dark-bg  statue_design status-row">
                    <span>Success</span>
                  </div>
                ) : version.option != "four" && version.status == "success" ? (
                  <div
                    className="col-sm-3 col-md-3 col-lg-2 dark-bg statue_design status-row "
                    onClick={function () {
                      history.push(
                        `/${eventContext.slug}/my-presentations/${PresentationId}/video/${version.versionId}/watch`
                      );
                    }}
                  >
                    <img
                      className="large "
                      src="/icons/video-completed.svg"
                      alt="file only"
                      width="32"
                    />
                    <span>Open</span>
                  </div>
                ) : version.status == "failed" ? (
                  <div className=" col-lg-2 bg-danger statue_design status-row">
                    <img
                      className="large status-loading_mo"
                      src="/icons/video-error1.svg"
                      alt="file only"
                      width="32"
                    />
                    <span>Error</span>
                  </div>
                ) : version.status == "processing" ||
                  version.status == "pending" ? (
                  // version.status == "Loading" ?
                  <div className="col-lg-2 statue_design dark-bg status-row">
                    <img
                      className="large status-loading_mo"
                      src="/icons/video-loading.svg"
                      alt="file only"
                      width="32"
                    />
                    <span className="loading-typography">Process </span>
                    {console.log(
                      "----------------------------------------version.percent",
                      version.percent
                    )}
                    <div className="outer_lining">
                      <ProgressBar
                        completed={version.percent ? version.percent : 0}
                        isLabelVisible={false}
                        height="2px"
                        bgColor="#24b2ff"
                        baseBgColor="#607c8b99"
                      />
                    </div>

                    {/* <div className="lininga"></div> */}
                  </div>
                ) : version.status === "PPT to PDF file convert failed" ? (
                  <div className="col-sm-3 col-md-3 col-lg-2 bg-danger status-row version-list-height" style={{ fontSize: 12, textAlign: "right", paddingTop: 10, paddingRight: 10, paddingLeft: 5 }}>
                    <img
                      className="large status-loading"
                      src="/icons/video-error1.svg"
                      alt="file only"
                      width="32"
                    />
                    <span >
                      PPT TO PDF FILE CONVERT FAILED
                    </span>
                  </div>
                ) : (
                  ""
                )}

                <Button
                  // col-sm-3 col-md-3
                  className="col-lg-2 light-bg right-border status_design"
                  onClick={
                    () => {
                      onStatusChange(!isOpen, version.status);
                      //  console.log(
                      //   `inside----------button onclick function  opendetails ${isOpen}`
                      // );
                    }

                    // setOpenDetails(!openDetails)
                  }
                  style={{ border: "none" }}
                >
                  {isOpen ? (
                    <img
                      className="large"
                      src="/icons/expand-close.svg"
                      alt="file only"
                      width="24"
                      style={{
                        marginTop: "25px",
                      }}
                    />
                  ) : (
                    <img
                      className="large"
                      src="/icons/expand-open.svg"
                      alt="file only"
                      width="24"
                      style={{
                        marginTop: "25px",
                      }}
                    />
                  )}

                </Button>
              </div>
            </div>
            {isOpen ? (
              version.option == "first" ? (
                <div className="col-sm-9 col-md-9 col-lg-9 padding-0 new-video-expand">
                  <div className="no-gutters row d-flex scroll-row">
                    <div className="col-sm-4 col-md-4 col-lg-4 scroll-item">
                      {version.webcam ? (
                        <>
                          <div onClick={() => openVideoModal(version.webcam)}>
                            <img
                              title="Presentation Video"
                              // cursour pointer
                              className="presentation_mobile"
                              src={`${url}`}
                            />
                          </div>
                        </>
                      ) : (
                        <img
                          className=""
                          src="/icons/video-close.svg"
                          alt="file only"
                          width="46"
                        />
                      )}
                    </div>

                    <div className="col-sm-4 col-md-4 col-lg-4  scroll-item">
                      <img
                        className="presentation_mobile"
                        src={"/icons/four.svg"}
                      />

                      {/* <img
                      className=""
                      src="/icons/presentation-close.svg"
                      alt="file only"
                      width="34"
                    /> */}
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4  scroll-item">
                      {version.video ? (
                        <>
                          <div onClick={() => openVideoModal(version.video)}>
                            <img
                              title="Presentation Video"
                              className="presentation_mobile"
                              src={`${videoUrl}`}
                            />
                          </div>
                        </>
                      ) : (
                        <img
                          className=""
                          src="/icons/video-close.png"
                          alt="file only"
                          width="55"
                        />
                      )}
                    </div>
                  </div>
                </div>
              ) : version.option == "two" ? (
                <div className="col-sm-9 col-md-9 col-lg-9 padding-0 new-video-expand">
                  <div className="no-gutters row d-flex scroll-row">
                    {/* <div className="col-sm-4 col-md-4 col-lg-4 scroll-item">
                    {version.webcam ? (
                      <>
                        <div onClick={() => openVideoModal(version.webcam)}>
                          <img
                            title="Presentation Video"
                            // cursour pointer
                            className="presentation_mobile"
                            src={`${url}`}
                          />
                        </div>
                      </>
                    ) : (
                      <img
                        className=""
                        src="/icons/video-close.svg"
                        alt="file only"
                        width="46"
                      />
                    )}
                  </div> */}

                    <div className="col-sm-4 col-md-4 col-lg-4  scroll-item">
                      <img
                        className="presentation_mobile"
                        src={"/icons/four.svg"}
                      />

                      {/* <img
                      className=""
                      src="/icons/presentation-close.svg"
                      alt="file only"
                      width="34"
                    /> */}
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4  scroll-item">
                      {version.video ? (
                        <>
                          <div onClick={() => openVideoModal(version.video)}>
                            <img
                              title="Presentation Video"
                              className="presentation_mobile"
                              src={`${videoUrl}`}
                            />
                          </div>
                        </>
                      ) : (
                        <img
                          className=""
                          src="/icons/video-close.png"
                          alt="file only"
                          width="55"
                        />
                      )}
                    </div>
                  </div>
                </div>
              ) : version.option == "three" ? (
                <div className="col-sm-9 col-md-9 col-lg-9 padding-0 new-video-expand">
                  <div className="no-gutters row d-flex scroll-row">
                    {/* <div className="col-sm-4 col-md-4 col-lg-4 scroll-item">
                    {version.webcam ? (
                      <>
                        <div onClick={() => openVideoModal(version.webcam)}>
                          <img
                            title="Presentation Video"
                            // cursour pointer
                            className="presentation_mobile"
                            src={`${url}`}
                          />
                        </div>
                      </>
                    ) : (
                      <img
                        className=""
                        src="/icons/video-close.svg"
                        alt="file only"
                        width="46"
                      />
                    )}
                  </div> */}

                    <div className="col-sm-4 col-md-4 col-lg-4  scroll-item">
                      <img
                        className="presentation_mobile"
                        src={"/icons/four.svg"}
                        alt="presentation file"
                      />

                      {/* <img
                      className=""
                      src="/icons/presentation-close.svg"
                      alt="file only"
                      width="34"
                    /> */}
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4  scroll-item">
                      {version.video ? (
                        <>
                          <div onClick={() => openVideoModal(version.video)}>
                            <img
                              title="Presentation Video"
                              className="presentation_mobile"
                              src={`${videoUrl}`}
                            />
                          </div>
                        </>
                      ) : (
                        <img
                          className=""
                          src="/icons/video-close.png"
                          alt="file only"
                          width="55"
                        />
                      )}
                    </div>
                  </div>
                </div>
              ) : version.option == "four" ? (
                <div className="col-sm-9 col-md-9 col-lg-9 padding-0 new-video-expand">
                  <div className="no-gutters row d-flex scroll-row">
                    <div className="col-sm-4 col-md-4 col-lg-4  scroll-item">
                      <img
                        className="presentation_mobile_version_four"
                        src={"/icons/four.svg"}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )
            ) : (
              ""
            )}
            {/* {isOpen &&
          //  {version.option == "first" ? "" : ""}

          (
            <div className="col-sm-9 col-md-9 col-lg-9 padding-0 new-video-expand">
              <div className="no-gutters row d-flex scroll-row">
                <div className="col-sm-4 col-md-4 col-lg-4 scroll-item">
                  {version.webcam ? (
                    <>
                      <div onClick={() => openVideoModal(version.webcam)}>
                        <img
                          title="Presentation Video"
                          // cursour pointer
                          className="presentation_mobile"
                          src={`${url}`}
                        />
                      </div>
                    </>
                  ) : (
                    <img
                      className=""
                      src="/icons/video-close.svg"
                      alt="file only"
                      width="46"
                    />
                  )}
                </div>

                <div className="col-sm-4 col-md-4 col-lg-4  scroll-item">
                  <img
                    className="presentation_mobile"
                    src={"/icons/four.svg"}
                  />

                  {/* <img
                      className=""
                      src="/icons/presentation-close.svg"
                      alt="file only"
                      width="34"
                    /> */}
            {/* </div>
                <div className="col-sm-4 col-md-4 col-lg-4  scroll-item">
                  {version.video ? (
                    <>
                      <div onClick={() => openVideoModal(version.video)}>
                        <img
                          title="Presentation Video"
                          className="presentation_mobile"
                          src={`${videoUrl}`}
                        />
                      </div>
                    </>
                  ) : (
                    <img
                      className=""
                      src="/icons/video-close.png"
                      alt="file only"
                      width="55"
                    />
                  )}
                </div> */}
            {/* </div>
            </div> */}
            {/* )}  */}
          </div>
        </div>
        <ValidationModel
          show={showValidationModal}
          handleClose={handleAlertModal}
          type={alertType}
          message={pptmessage}
          onYesClick={function (version_Id: any) {
            deleteVersion(version.versionId);
          }}
        />
        <AlertModal
          show={showAlertModal}
          handleClose={handleLoadingAlertModal}
          type="Progress"
          progress={progress}
          message={intl.formatMessage({ id: 'uploading.webcam.message' })}
        />
      </div>
    );
  };

export default NewVideoItem;
